import $$ from 'cmn-utils';
import modelEnhance from '@/utils/modelEnhance';
import { routerRedux } from 'dva/router';

export default modelEnhance({
  namespace: 'global',

  state: {
    menu: [],
    flatMenu: [],
  },

  effects: {
    *getMenu({ payload }, { call, put }) {
      
      const { ret, data } = yield call(getMenu, payload);
      
      if (ret === 200) {

        let menuData = []
        
        menuData.push({
          name: '首页',
          icon: 'DashboardOutlined',
          path: '/dashboard',
          sort: 1
        })

        const newData = data.adm.children;
        for(let i in newData){
          let pitem = {}
          pitem.name = newData[i].title;
          pitem.path = newData[i].path;
          pitem.sort = newData[i].sort;
          if(newData[i].icon) pitem.icon = newData[i].icon;
          if (newData[i].children) {
            pitem.children = [];
            for(let j in newData[i].children){
              let pjitem = {};
              pjitem.name = newData[i].children[j].title;
              pjitem.path = newData[i].children[j].path;
              pjitem.sort = newData[i].children[j].sort;
              if(newData[i].children[j].icon) pjitem.icon = newData[i].children[j].icon
              
              pitem.children.push(pjitem);
            }
            pitem.children.sort((a,b)=>{
              return a.sort - b.sort
            })
          }

          menuData.push(pitem);
        }
        menuData.push({
          name: '修改个人信息',
          icon: 'UserOutlined',
          path: '/user/info',
          sort: 999
        })
        const menuDataOder = menuData.sort((a,b)=>{
          return a.sort - b.sort
        })
        console.log('all:',menuDataOder);
        

        const loopMenu = (menu, pitem = {}) => {
          menu.forEach(item => {
            if (pitem.path) {
              item.parentPath = pitem.parentPath ? pitem.parentPath.concat(pitem.path) : [pitem.path];
            }
            if (item.children && item.children.length) {
              loopMenu(item.children, item);
            }
          });
        }
        loopMenu(menuData);
        yield put({
          type: 'getMenuSuccess',
          payload: menuData,
        });
      }
    else if(ret === 402){
      $$.removeStore('user');
      $$.removeStore('ssid');
      //const currentURL = window.location.hash
      //yield put(routerRedux.replace('/sign/login?redirect='+ currentURL))
    }
    },
  },

  reducers: {
    getMenuSuccess(state, { payload }) {
      return {
        ...state,
        menu: payload,
        flatMenu: getFlatMenu(payload),
      };
    }
  },
});

export function getFlatMenu(menus) {
  let menu = [];
  menus.forEach(item => {
    if (item.children) {
      menu = menu.concat(getFlatMenu(item.children));
    }
    menu.push(item);
  });
  return menu;
}

export async function getMenu(payload) {
  return $$.post('/auth/role/getAccess', payload);
}